import React, { Fragment } from "react";
import { useFormState, useForm } from "react-final-form";
import { NumberInput } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { perGameCalc, getPerGameStatValue } from "util/stats";
import _ from "lodash";

const useStyles = makeStyles({
  input: {
    marginRight: "10px"
  }
});

const Tab = () => {
  const { values } = useFormState();
  const form = useForm();
  const classes = useStyles();

  const updateStat = (event, updateField) => {
    const gameCount = _.get(values, "girlsvolleyball.playerGameCount");
    const perGameStat = getPerGameStatValue(event, gameCount);
    form.change(`girlsvolleyball.${updateField}`, perGameStat);
  };

  const updateAllRelatedStats = (event) => {
    if (!event || !event.target) return;
    const { value } = event.target;
    const { kills, aces, digs, blocks, assists } = values.girlsvolleyball;
    const killsPerGame = perGameCalc(kills, value);
    const acesPerGame = perGameCalc(aces, value);
    const digsPerGame = perGameCalc(digs, value);
    const blocksPerGame = perGameCalc(blocks, value);
    const assistsPerGame = perGameCalc(assists, value);
    form.change("girlsvolleyball.killsPerGame", killsPerGame);
    form.change("girlsvolleyball.acesPerGame", acesPerGame);
    form.change("girlsvolleyball.digsPerGame", digsPerGame);
    form.change("girlsvolleyball.blocksPerGame", blocksPerGame);
    form.change("girlsvolleyball.assistsPerGame", assistsPerGame);
  };

  return (
    <Fragment>
      <NumberInput
        className={classes.input}
        source="girlsvolleyball.playerGameCount"
        onChange={updateAllRelatedStats}
      />
      <br></br>
      <NumberInput
        className={classes.input}
        source="girlsvolleyball.kills"
        onChange={(e) => updateStat(e, "killsPerGame")}
      />
      <NumberInput
        className={classes.input}
        source="girlsvolleyball.assists"
        onChange={(e) => updateStat(e, "assistsPerGame")}
      />
      <NumberInput
        className={classes.input}
        source="girlsvolleyball.aces"
        onChange={(e) => updateStat(e, "acesPerGame")}
      />
      <NumberInput
        className={classes.input}
        source="girlsvolleyball.blocks"
        onChange={(e) => updateStat(e, "blocksPerGame")}
      />
      <NumberInput
        className={classes.input}
        source="girlsvolleyball.digs"
        onChange={(e) => updateStat(e, "digsPerGame")}
      />
      <br></br>
      <NumberInput
        className={classes.input}
        disabled
        source="girlsvolleyball.killsPerGame"
      />
      <NumberInput
        className={classes.input}
        disabled
        source="girlsvolleyball.assistsPerGame"
      />
      <NumberInput
        className={classes.input}
        disabled
        source="girlsvolleyball.acesPerGame"
      />
      <NumberInput
        className={classes.input}
        disabled
        source="girlsvolleyball.blocksPerGame"
      />
      <NumberInput
        className={classes.input}
        disabled
        source="girlsvolleyball.digsPerGame"
      />
    </Fragment>
  );
};

export default Tab;
